import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { sendAmplitudeEvents } from 'utils/common';

import { EventNames } from 'utils/events';

function useFolderStructure({ artefactContentStructure }) {
  const userInfo = useSelector((state) => state.userInfo?.userInfo);
  const auth = useMemo(() => {
    return {
      username: userInfo.data && userInfo.data.username,
      password: userInfo.data && userInfo.data.apiToken,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo?.data?.username, userInfo?.data?.apiToken]);

  const [activeEventKey, setActiveEventKey] = useState(null);
  const [folderStructure, setFolderStructure] = useState(
    artefactContentStructure?.data?.data
  );
  function setActiveEventKeyAccordian(key) {
    setActiveEventKey(key);
  }
  useEffect(() => {
    setFolderStructure(artefactContentStructure?.data?.data);
  }, [artefactContentStructure?.data?.data]);

  function handleFolderClick(folder) {
    if (folder.type === 'folder') {
      function findFolderAndInsertFiles(filesAndFolders) {
        const isFolderMatched = folder.key === filesAndFolders.key;
        if (isFolderMatched && filesAndFolders.isOpen === false) {
          filesAndFolders.isOpen = true;
        } else if (isFolderMatched && filesAndFolders.isOpen === true) {
          filesAndFolders.isOpen = false;
        } else if (filesAndFolders.type === 'folder') {
          for (let i = 0; i < filesAndFolders.files.length; i++) {
            findFolderAndInsertFiles(filesAndFolders.files[i]);
          }
        }
      }
      let data = { ...folderStructure };
      findFolderAndInsertFiles(data);
      setFolderStructure(data);
      const params = {};
      params['action'] = 'collapse';
      params['level'] = folder.level;
      params['folderName'] = folder.name;
      params['count'] = folder?.files?.length;
      if (folder.isOpen) {
        params['action'] = 'expand';
      }

      sendAmplitudeEvents(EventNames.HYP_USER_INTERACTED_WITH_FOLDER, params);
    }
  }

  function downloadArtefactLink(artefact, type = 'download') {
    /*
      ! If you are making change here,
      Please visit this function as well, it does same thing.
      openArtifactInSamePage src/hooks/useArtifacts.js
    */
    let downloadLink = artefact?.download_link;

    const headers = {
      Authorization:
        'Basic ' +
        Buffer.from(auth.username + ':' + auth.password).toString('base64'),
    };
    fetch(downloadLink, {
      headers,
    })
      .then((res) => {
        return res.blob();
      })
      .then((blob) => {
        if (type === 'open') {
          var fileURL = window.URL.createObjectURL(blob);
          window.open(fileURL);
        } else {
          let url = window.URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.href = url;
          link.download = `${artefact.name}`;
          link.click();
        }
      });
  }

  return {
    activeEventKey,
    setActiveEventKeyAccordian,
    folderStructure,
    handleFolderClick,
    downloadArtefactLink,
  };
}
export default useFolderStructure;
